import {
    ACCOUNT_VERIFIED_ROUTE,
    CAPTURE_MAP_ROUTE,
    CAPTURE_PROFILE_ROUTE,
    LOGIN_ROUTE,
    SIGN_UP_ROUTE,
    VERIFICATION_ROUTE
} from '../../constants/routes';
import { MantaCareUser } from '../../context/UserContext/types';

export const onboardingRoutes = [
    LOGIN_ROUTE,
    SIGN_UP_ROUTE,
    ACCOUNT_VERIFIED_ROUTE,
    VERIFICATION_ROUTE,
    CAPTURE_PROFILE_ROUTE,
    CAPTURE_MAP_ROUTE
];

/**
 * Determines the next onboarding route based on the provided user data.
 */
export const getOnboardingRoute = (user: MantaCareUser | undefined, pathname: string) => {
    /**
     * The onboarding routes to follow in order:
     * 1. Verification route
     * 2. Capture profile route
     * 3. Questionnaires route
     */
    if (pathname == ACCOUNT_VERIFIED_ROUTE && !user) {
        return ACCOUNT_VERIFIED_ROUTE;
    }
    if (!user || !user.name) {
        return CAPTURE_PROFILE_ROUTE;
    }
    if (!user.hasCompletedOnboardingQuestionnaire) {
        return CAPTURE_PROFILE_ROUTE;
    }

    return null;
};

export const isBeforeCaptureProfileRoute = (route: string) => {
    return [LOGIN_ROUTE, SIGN_UP_ROUTE, CAPTURE_PROFILE_ROUTE, ACCOUNT_VERIFIED_ROUTE, VERIFICATION_ROUTE].includes(route);
};

export const addSearchParams = (search: string, params: { [key: string]: string }) => {
    const searchParams = new URLSearchParams(search);
    Object.keys(params).forEach(key => {
        searchParams.set(key, params[key]);
    });
    return searchParams.toString();
};

export const addRedirectParam = (search: string, path: string) => {
    if (!path) return search;
    if (onboardingRoutes.includes(path)) return search;
    return addSearchParams(search, { redirectTo: path });
};
